import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/hyperlink/style.scss";
import "@ingka/inline-message/style.scss";
import "@ingka/focus/style.scss";

import InlineMessage from "@ingka/inline-message";

export default function Message(props) {
  return (
    <div style={{margin: "1rem 0"}}>
      <InlineMessage {...props} />
    </div>
    
  )
}
